import { render, staticRenderFns } from "./shenpibohui.vue?vue&type=template&id=745463fc&scoped=true&"
import script from "./shenpibohui.vue?vue&type=script&lang=js&"
export * from "./shenpibohui.vue?vue&type=script&lang=js&"
import style0 from "./shenpibohui.vue?vue&type=style&index=0&id=745463fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745463fc",
  null
  
)

export default component.exports